// api/services/channels.ts
import { handleRequest } from '@/api';
import type { Channel } from '@/types';

interface FetchOpts {
    signal?: AbortSignal;
}

interface ChannelPayload {
    display_name: string;
    owner_type: 'broadcaster' | 'adtech';
    owner_id: number;
    channel_type: 1 | 3;
    country_codes: string[];
}

interface ChannelUpdatePayload extends ChannelPayload {
    id: number;
}

interface ChannelOperationResponse {
    message: string;
    channel_id: number;
}

export const getChannels = (opts: FetchOpts = {}): Promise<Channel[]> =>
    handleRequest<Channel[]>('get', '/channels/', opts);

export const createChannel = (channelData: ChannelPayload): Promise<ChannelOperationResponse> =>
    handleRequest<ChannelOperationResponse>('post', '/channels/', channelData, 'Channel created successfully!');

export const updateChannel = (payload: ChannelUpdatePayload): Promise<ChannelOperationResponse> =>
    handleRequest<ChannelOperationResponse>('put', `/channels/${payload.id}`, payload, 'Channel updated successfully');
